import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import userLogout from 'redux/actions/userLogout';
import isLoggedIn from 'global/utils/isLoggedIn';
import { LogoutGrid, LogoutLoadingPaper, LogoutLoadingPaperProgress } from './UserLogout.styles';

export default function Logout() {
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));
  const dispatch = useDispatch();

  const renderRedirect = (redirect) => {
    if (!redirect) {
      return <Redirect to="/" />;
    }
  };

  useEffect(() => {
    if (loggedIn === true) {
      dispatch(userLogout());
    }
  }, []);

  return (
    <LogoutGrid justifyContent="center" alignItems="center" container>
      <Grid item xs={10} lg={6}>
        <LogoutLoadingPaper>
          {renderRedirect(loggedIn)}
          <Typography component="h1" variant="h5">
            Bye Bye!
          </Typography>
          <LogoutLoadingPaperProgress color="secondary" />
          <Typography variant="subtitle1">Hang on, we're erasing your footsteps and sweeping away the breadcrumbs.</Typography>
        </LogoutLoadingPaper>
      </Grid>
    </LogoutGrid>
  );
}
